if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        const showingMore = this.querySelector('.label-show-more').classList.contains('hidden');
        
        // Toggle labels
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        
        // Get the list container and all items
        const listContainer = parentDisplay.querySelector('ul');
        const allItems = Array.from(listContainer.querySelectorAll('li.facets__item'));
        
        // First, show/hide the items
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        
        // Then sort them based on the state (showing more or less)
        if (!showingMore) {
          // User clicked "Show More" - sort alphabetically
          allItems.sort((a, b) => {
            const labelA = a.querySelector('.facet-checkbox__text-label').textContent.trim().toLowerCase();
            const labelB = b.querySelector('.facet-checkbox__text-label').textContent.trim().toLowerCase();
            return labelA.localeCompare(labelB);
          });
        } else {
          // User clicked "Show Less" - sort by count (quantity available)
          allItems.sort((a, b) => {
            const countA = parseInt(a.querySelector('.text-subdued').textContent, 10);
            const countB = parseInt(b.querySelector('.text-subdued').textContent, 10);
            return countB - countA; // Descending order
          });
        }
        
        // Remove all items and append them in the new order
        allItems.forEach(item => listContainer.appendChild(item));
        
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}